import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import type { RentersClaimFormValues } from '../page.claims.renters.hook'

type FileFieldName = 'documents' | 'photos'

export function useClaimsRentersStepTwo() {
  const { t } = useTranslation()
  const {
    control,
    setValue,
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext<RentersClaimFormValues>()

  // The "at least one attachment" rule lives on `documents` but depends on
  // `photos` too, so both lists re-run it whenever they change
  const rules = {
    documents: {
      validate: (files: File[]) =>
        files.length + getValues('photos').length > 0 ||
        t('claims.renters.form.attachmentsError'),
    },
  }

  const fieldErrors = {
    attachments: errors.documents?.message,
  }

  function addFiles(name: FileFieldName, files: File[]) {
    setValue(name, [...getValues(name), ...files], { shouldDirty: true })
    trigger('documents')
  }

  function removeFile(name: FileFieldName, index: number) {
    setValue(
      name,
      getValues(name).filter((_, fileIndex) => fileIndex !== index),
      { shouldDirty: true },
    )
    trigger('documents')
  }

  return { control, rules, fieldErrors, addFiles, removeFile }
}
